import React from "react";
import { default as ManageFormParent } from "./ManageForms";
import { Provider } from "react-redux";

function ManageForms() {
  return <ManageFormParent />;
}

export default ManageForms;
